import { render, staticRenderFns } from "./WebsiteForm.vue?vue&type=template&id=220fa6ea&scoped=true"
import script from "./WebsiteForm.vue?vue&type=script&lang=js"
export * from "./WebsiteForm.vue?vue&type=script&lang=js"
import style0 from "./WebsiteForm.vue?vue&type=style&index=0&id=220fa6ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220fa6ea",
  null
  
)

export default component.exports